export default __webpack_public_path__ + "static/LUTEIN-BILBERRY-MARIGOLDS-31d9efae6232f7712e3e3fb80bd5d320.jpg";